module.exports = __webpack_public_path__ + "img/2025-10-15a_3.3c83ae47.jpg";